import {css} from 'styled-components';

export default css`
  .returned-quantity-input {
    margin-bottom: 5px;
  }
`
